import styled from 'styled-components';
import { Text } from '@cashfree-intl/coherent';

export const StyledTransferField = styled(Text)`
  min-width: 11rem;
  text-align: left;
`;
